import Vue from 'vue'

export default {
  get: function() {
    return Vue.prototype.$prismic.client
  }
}
